import genericContentItem from '@shared/components/mixins/genericContentItem'
import genericContentItemAnswer from '@shared/components/mixins/genericContentItemAnswer'
import pxToEm from '@shared/components/mixins/shared/pxToEm'

export default {
  name: 'SurveyComponent',
  mixins: [genericContentItem, genericContentItemAnswer, pxToEm],
  props: {
    validation: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      hoverIndex: '',
    }
  },
  computed: {
    componentStyles() {
      const styles = JSON.parse(JSON.stringify(this.emStyling))
      delete styles.backgroundColor

      return styles
    },
  },
  watch: {
    hoverIndex(val, oldVal) {
      if (oldVal !== '') {
        this.$refs.survey.children[oldVal].firstChild.style.opacity = 0.4
      }

      if (val !== '') {
        this.$refs.survey.children[val].firstChild.style.opacity = 1
      }
    },
  },
  methods: {
    triggerSelectValue: function(value) {
      this.answer.optionID = value.id
      this.answer.value = value.text
      this.$eventBus.$emit('survey-answer', this.answer)
    },
  },
}
